module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reg-tea1st"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.error) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s(_vm.error))])])]) : _vm._e(), (_vm.socialType === 1) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('md-fg-input', {
    class: [_vm.isSubmitStep && (_vm.username.length < 3 || _vm.checkName !== null) ? 'error' : ''],
    attrs: {
      "label": "Tên đăng nhập *",
      "labelFloating": false,
      "type": "text",
      "required": true,
      "placeholder": "Nhập"
    },
    on: {
      "input": _vm.checkUserName
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "col-md-12"
  }, [_c('md-fg-input', {
    class: [_vm.isSubmitStep && _vm.fullname.length === 0 ? 'error' : ''],
    attrs: {
      "label": "Tên hiển thị *",
      "labelFloating": false,
      "type": "text",
      "required": true,
      "placeholder": "Nhập",
      "maxlength": "125"
    },
    model: {
      value: (_vm.fullname),
      callback: function($$v) {
        _vm.fullname = $$v
      },
      expression: "fullname"
    }
  })], 1), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.socialType === 1) ? _c('md-fg-input', {
    class: [_vm.isSubmitStep && !_vm.validMail ? 'error' : ''],
    attrs: {
      "label": "Email *",
      "labelFloating": false,
      "type": "email",
      "required": true,
      "placeholder": "example@gmail.com"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }) : _c('md-fg-input', {
    attrs: {
      "label": "Email *",
      "labelFloating": false,
      "type": "email",
      "disabled": true,
      "placeholder": "example@gmail.com"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group custom-form-group",
    class: [_vm.isSubmitStep && _vm.phone_number.length === 0 ? 'error' : '']
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Số điện thoại")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone_number),
      expression: "phone_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "phone_number",
      "placeholder": "Nhập",
      "autocomplete": "off",
      "required": false,
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.phone_number)
    },
    on: {
      "keypress": _vm.isAllow,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone_number = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "col-md-12"
  }, [_c('md-fg-input', {
    class: [_vm.isSubmitStep && _vm.isDate ? 'error' : ''],
    attrs: {
      "label": "Ngày sinh của bạn",
      "labelFloating": false,
      "type": "date",
      "required": false
    },
    model: {
      value: (_vm.birthday),
      callback: function($$v) {
        _vm.birthday = $$v
      },
      expression: "birthday"
    }
  })], 1), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group custom-form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Trường bạn đang công tác")]), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "school_id"
    },
    on: {
      "change": function($event) {
        return _vm.onChangeSchool($event)
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "true",
      "disabled": "disabled"
    }
  }, [_vm._v("Chọn")]), _vm._l((_vm.schools), function(o, index) {
    return _c('option', {
      domProps: {
        "value": o.id,
        "selected": o.id === _vm.selectedSchool
      }
    }, [_vm._v(_vm._s(o.name))])
  })], 2)])]), (_vm.socialType === 1) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group custom-form-group",
    class: [_vm.isSubmitStep && this.password.length < 6 ? 'error' : ''],
    staticStyle: {
      "position": "relative"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Mật khẩu đăng nhập *")]), ((_vm.passwordType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-right": "40px !important"
    },
    attrs: {
      "id": "password",
      "required": "required",
      "placeholder": "Nhập",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.password) ? _vm._i(_vm.password, null) > -1 : (_vm.password)
    },
    on: {
      "keyup": _vm.checkPassword,
      "change": function($event) {
        var $$a = _vm.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.password = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.password = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.password = $$c
        }
      }
    }
  }) : ((_vm.passwordType) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-right": "40px !important"
    },
    attrs: {
      "id": "password",
      "required": "required",
      "placeholder": "Nhập",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.password, null)
    },
    on: {
      "keyup": _vm.checkPassword,
      "change": function($event) {
        _vm.password = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-right": "40px !important"
    },
    attrs: {
      "id": "password",
      "required": "required",
      "placeholder": "Nhập",
      "type": _vm.passwordType
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": _vm.checkPassword,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), (_vm.passwordType === 'text') ? _c('i', {
    staticClass: "material-icons reg-tea1st-icon-password",
    on: {
      "click": _vm.switchVisibility1st
    }
  }, [_vm._v("visibility")]) : _c('i', {
    staticClass: "material-icons reg-tea1st-icon-password",
    on: {
      "click": _vm.switchVisibility1st
    }
  }, [_vm._v("visibility_off")])])]) : _vm._e(), (_vm.socialType === 1) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group custom-form-group",
    class: [_vm.isSubmitStep && (!this.matched || this.second_password.length < 6) ? 'error' : ''],
    staticStyle: {
      "position": "relative"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Nhập lại mật khẩu *")]), ((_vm.secondPasswordType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.second_password),
      expression: "second_password"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-right": "40px !important"
    },
    attrs: {
      "id": "second_password",
      "required": "required",
      "placeholder": "Nhập",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.second_password) ? _vm._i(_vm.second_password, null) > -1 : (_vm.second_password)
    },
    on: {
      "keyup": _vm.checkPassword,
      "change": function($event) {
        var $$a = _vm.second_password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.second_password = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.second_password = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.second_password = $$c
        }
      }
    }
  }) : ((_vm.secondPasswordType) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.second_password),
      expression: "second_password"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-right": "40px !important"
    },
    attrs: {
      "id": "second_password",
      "required": "required",
      "placeholder": "Nhập",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.second_password, null)
    },
    on: {
      "keyup": _vm.checkPassword,
      "change": function($event) {
        _vm.second_password = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.second_password),
      expression: "second_password"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-right": "40px !important"
    },
    attrs: {
      "id": "second_password",
      "required": "required",
      "placeholder": "Nhập",
      "type": _vm.secondPasswordType
    },
    domProps: {
      "value": (_vm.second_password)
    },
    on: {
      "keyup": _vm.checkPassword,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.second_password = $event.target.value
      }
    }
  }), (_vm.secondPasswordType === 'text') ? _c('i', {
    staticClass: "material-icons reg-tea1st-icon-password",
    on: {
      "click": _vm.switchVisibility2nd
    }
  }, [_vm._v("visibility")]) : _c('i', {
    staticClass: "material-icons reg-tea1st-icon-password",
    on: {
      "click": _vm.switchVisibility2nd
    }
  }, [_vm._v("visibility_off")])])]) : _vm._e(), _c('div', {
    staticClass: "col-md-12 lo-custom-footer"
  }, [_c('div', {
    staticClass: "col-md-6 col-12"
  }, [_c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "reg-tea1st-btn-validate btn",
    on: {
      "click": _vm.validateContinue
    }
  }, [_vm._v("Tiếp tục")])])]), _c('div', {
    staticClass: "col-md-6 col-12"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "reg-tea1st-btn-cancel btn",
    on: {
      "click": _vm.backLogin
    }
  }, [_vm._v("Quay lại")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-626b02f5","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Account/itemRegisterTeacher1.vue
// module id = 1584
// module chunks = 0